import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../utils/utils';
import { editManufacture, ManufactureParams } from '../../../../crud/manufacturer.crud';

export const useEditManufacture = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const handleManufacture = async (id: number, params: ManufactureParams) => {
    setLoading(true);
    editManufacture(id, params)
      .then(() => {
        setSuccess(true);
        enqueueSnackbar(`Производитель успешно изменен`, {
          variant: 'success',
        });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 100);
      });
  };
  return { handleManufacture, loading, success };
};
